export default function PHP_strpbrk() {
  return (
    <div>
      <h1>PHP_strpbrk</h1>
    </div>
  );
}
